import { isEmptyObject, getExpressionBodyTokens } from "../../lib/utils";
import { AggregateFunction } from "../../lib/aggregatefunctions";
import { ComputedFieldFunction } from "../../lib/computedfieldfunction";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values) => 
{
    let formErrors = {};

    let title = values["Title"];
    let typeId = values["TypeId"];
    let isAggregate = values["IsAggregate"];
    let aggregateExpressionId = values["AggregateExpressionId"];
    let aggregateFunctionId = values["AggregateFunctionId"];
    let fieldId = values["FieldId"];
    let fields = values.Fields;
    let isSystem = values["IsSystem"];

    if (!title || title.trim().length == 0)
        formErrors = Object.assign(formErrors, {Title: i18next.t("onboarding.title_error")});
    else if (!isSystem && title.trim().indexOf("©") >= 0)
        formErrors = Object.assign(formErrors, {Title: i18next.t("onboarding.title_error2")});
  
    
    if (typeId == 1)
    {
        if (isAggregate)
        {
            if (aggregateExpressionId == null)
                formErrors = Object.assign(formErrors, {AggregateExpressionId: i18next.t("onboarding.agg_expression_error")});
            
            if (aggregateFunctionId > 0)
                formErrors = Object.assign(formErrors, {AggregateFunctionId: i18next.t("onboarding.agg_function_error")});
            
            if (fieldId != null)
                formErrors = Object.assign(formErrors, {FieldId: i18next.t("onboarding.field_error")});
        } 
        else
        {
            if (aggregateExpressionId != null)
                formErrors = Object.assign(formErrors, {AggregateExpressionId: i18next.t("onboarding.agg_expression_error2")});

            if (aggregateFunctionId <= 0 || !AggregateFunction.functions.find(e => e.id == aggregateFunctionId))
               formErrors = Object.assign(formErrors, {AggregateFunctionId: i18next.t("datasources.agg_error")});
        
            if (fieldId == null)
                formErrors = Object.assign(formErrors, {FieldId:  i18next.t("onboarding.field_error2")});
        }
    }
    else
    {
        //table data source            
        if (fields && fields.length > 0)
        {
            let isGrouped = fields.filter(e => (e.IsComputedField == false && e.FunctionId > 0) || e.FieldIsAggregate == true).length > 0;
            let rowNumber = 1;

            let sortedFields = [...fields].sort((a, b) => (a.OrderId < b.OrderId) ? -1 : (a.OrderId == b.OrderId ? 0 : 1));

            //duplication
            for (let i in sortedFields)
            {
                if (!sortedFields[i].Title || sortedFields[i].Title.trim() == "")
                {
                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.titlerequired")});
                    return formErrors;
                }
                else if (sortedFields.filter(e => e.Title.trim().toLowerCase() == sortedFields[i].Title.trim().toLowerCase()).length > 1)
                {
                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.sametitle_error")});
                    return formErrors;
                }

                if (sortedFields.filter(e => e.IsComputedField == false && e.FunctionId == sortedFields[i].FunctionId && e.FieldId == sortedFields[i].FieldId).length > 1)
                {
                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.field_error")});
                    return formErrors;
                }
                else  if (sortedFields.filter(e => e.IsComputedField == true && e.HasComputedFunction == true && e.FunctionId == sortedFields[i].FunctionId && e.ParentFieldId == sortedFields[i].ParentFieldId).length > 1)
                {
                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.field_error2")});
                    return formErrors;
                }

                if (sortedFields[i].IsComputedField == true && sortedFields[i].HasComputedFunction == true)
                {
                    let parentFieldId = sortedFields[i].ParentFieldId;
                    let parentField = sortedFields.find(e => e.Id == parentFieldId);
                    
                    if (!parentField)
                    {
                        formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.parentfield_error")});
                        return formErrors;
                    }
                    else if (parentField.IsComputedField == true && parentField.OrderId > sortedFields[i].OrderId)
                    {
                        formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.parentfield_error2")});
                        return formErrors;
                    }
                    else
                    {
                        let computedFunction = ComputedFieldFunction.getById(sortedFields[i].FunctionId);
                        if (!computedFunction.appliesToDataType(parentField.DataTypeId))
                        {
                            formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.parentfield_error3")});
                            return formErrors;
                        }
                    }
                }
                else if (sortedFields[i].IsComputedField == true && sortedFields[i].HasExpressionBody == true)
                {
                    let res = getExpressionBodyTokens(sortedFields[i].ExpressionBody);
                    if (!res.status)
                    {
                        formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.expression_error")});
                        return formErrors;
                    }
                    else
                    {
                        if (res.tokens?.length > 0)
                        {
                            for (let tk in res.tokens)
                            {
                                let token = res.tokens[tk].trim().toLowerCase();
                                let f = sortedFields.find(e => e.Title.trim().toLowerCase() == token);

                                if (!f)
                                {
                                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.expression_error1") + res.tokens[tk] + i18next.t("datasources.expression_error2")});
                                    return formErrors;
                                }
                                else if (f.Id == sortedFields[i].Id)
                                {
                                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.expression_error3")});
                                    return formErrors;
                                }
                                else if (f.OrderId >= sortedFields[i].OrderId)
                                {
                                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.expression_error4")});
                                    return formErrors;
                                }
                            }
                        }
                    }
                }

                if(isGrouped && sortedFields[i].IsComputedField == false && !sortedFields[i].FieldIsAggregate && sortedFields[i].FunctionId <= 0) 
                {
                    formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.row_error") + rowNumber + i18next.t("datasources.datagroup")});
                    return formErrors;
                }

                rowNumber++;
            }          

            // //if is grouped => every NAF must have grouped or af
            // if (isGrouped)            
            // {
            //     for (let i in fields)
            //     {
            //         if (fields[i].IsComputedField == false && !fields[i].FieldIsAggregate && fields[i].FunctionId <= 0)
            //         {
            //             formErrors = Object.assign(formErrors, {Fields: "Error at row " + (i+1).toString() + ": When the data source is grouped, every non-aggregate field must be either grouped by or has an aggregate function assigned"});
            //             return formErrors;
            //         }
            //     }
            // }
        }
        else
            formErrors = Object.assign(formErrors, {Fields: i18next.t("datasources.selection")});
    }

    if (isEmptyObject(formErrors))
       return undefined;
    
    return formErrors;        
}